<template>
  <div class="_index">
    <!-- 轮播 -->
    <section class="lm animate__animated animate__fadeIn">
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <div class="left-deal">
            <div class="left-deal-autoText">
              <el-carousel
                indicator-position="none"
                height="44px"
                direction="vertical"
              >
                <el-carousel-item v-for="item in tips" :key="item">
                  <div class="item notice-item">
                    <img :src="item[0]" />
                    <div style="flex:1">
                      <div class="scale">{{ item[1] }}{{ item[2] }}小时前 </div>
                    </div>

                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="txtWrap">
              <div class="left-deal-t1">交易请使用USDT(TRC20)</div>
              <br/>
              <div class="left-deal-t2">加入代理优惠价￥13888</div>
              <div class="left-deal-t3">【普通用户可直接购买卡密，无需开通代理】</div>
              <div class="left-deal-t3">
                <a href="https://t.me/Crowncard888" target="_blank">
                未使用过USDT的可通过下方常见问题介绍，自行下载交易所购买，或联系TG客服获取教程。
                </a>
              </div>

<!--              <div class="left-deal-t4">了解详细网站教程，请点击下方查看</div>-->
<!--              <a @click="showVideo" style="cursor: pointer"><div class="left-deal-t5" >⭐️⭐️卡密项目视频介绍⭐️⭐️</div></a>-->

              <br/> <br/> <br/>
              <div class="left-deal-b1 goDealBtn dark">
                <el-button type="primary" round @click="goCardDetail">
                  加入代理
                </el-button>
                <a href="https://t.me/Crownbidirectionalbot" target="_blank">
                  <el-button type="warning" round>
                    联系客服
                  </el-button>
                </a>
                <router-link to="buy?id=1">
                  <el-button type="success" class="buy_one" round>
                    点击购买单张测试
                  </el-button>
                </router-link>
              </div>
            </div>

            <el-dialog title="视频教学" :visible.sync="open" :width="dialogWidth" append-to-body @close="closeDialog">
              <div>
                <el-row>
                  <div class="video-box">
                    <div class="video">
                      <!--这里即是引用的组件，外层css可以修饰播放器的样式-->
                      <video-js ref="videoJs" :options="videoOptions" class="video-css"/>
                    </div>
                  </div>
                </el-row>
              </div>
            </el-dialog>


          </div>
        </el-col>
      </el-row>
    </section>

    <!-- nav简单易用 -->
    <section class="animate__animated animate__fadeInUp user-guide-wrap">
      <div class="main-section-title">简单易用</div>
      <div class="main-section-description" style="color: rgb(142, 129, 158);">
        获取卡密的四个简单步骤。 你还在等什么？
      </div>
      <el-row class="box">
        <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
          <div class="step-item" @click="scrollNum('question')">
            <div class="step-img-wrap">
              <span class="step-img-wrap-index">1</span>
              <img class="svg-icon" :src="c1" />
            </div>
            <div class="step-description-wrap">
              <p class="step-description-wrap-t">常见问题</p>
              <p
                class="step-description-wrap-d"
                style="color: rgb(142, 129, 158);"
              >
                帮助新手朋友快速解决疑问
              </p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
          <div class="step-item" @click="goCard">
            <a href="javascrtipt:;" class=""
              ><div class="step-img-wrap">
                <span class="step-img-wrap-index">2</span
                ><img class="svg-icon" :src="c2" /></div
            ></a>
            <div class="step-description-wrap">
              <p class="step-description-wrap-t">购买</p>
              <p
                class="step-description-wrap-d"
                style="color: rgb(142, 129, 158);"
              >
                选择需要的卡种，进行支付购买
              </p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
          <div class="step-item" @click="goUser">
            <div class="step-img-wrap">
              <span class="step-img-wrap-index">3</span
              ><img class="svg-icon" :src="c3" />
            </div>
            <div class="step-description-wrap">
              <p class="step-description-wrap-t">获取卡密</p>
              <p
                class="step-description-wrap-d"
                style="color: rgb(142, 129, 158);"
              >
                个人中心获取购买后的卡号卡密
              </p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
          <div class="step-item" @click="scrollNum('question')">
            <div class="step-img-wrap">
              <span class="step-img-wrap-index">4</span
              ><img class="svg-icon" :src="c4" />
            </div>
            <div class="step-description-wrap">
              <p class="step-description-wrap-t">置换&amp;售卖</p>
              <p
                class="step-description-wrap-d"
                style="color: rgb(142, 129, 158);"
              >
                闲鱼app官方置换，赚取差价佣金
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="">
        <el-button type="primary" round @click="goCard">
          点击进入
        </el-button>
      </div>
    </section>

    <!-- 常见问题 -->
    <section class="animate__animated animate__fadeInUp qusetion main-section">
      <div class="main-setion-wrap">
        <div class="main-section-title"> 常见问题</div>
        <div class=" main-section-description">您所担心的这里都可以找到</div>
        <div class="card-preview-main">
          <el-row class="guide-step-wrap" id="question">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="left-preview-img">
                <div id="sell-jump" class="left-preview-img-wrap">
                  <h4 class="tit">请仔细阅读以下问题</h4>
                  <img :src="recordPic" class="svg-icon" />
                </div>
              </div>
            </el-col>
            <el-col :span="24">
              <el-collapse class="right-preview-description" v-model="QA">
                <el-collapse-item
                  :key="index"
                  :title="item.title"
                  :name="index"
                  v-for="(item, index) in helpList"
                >
                  <div v-html="item.html">

                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-col>
          </el-row>
        </div>
      </div>
    </section>

    <!-- 客户评价 -->
    <section class="animate__animated animate__fadeInUp client main-section">
      <div class="main-setion-wrap">
        <div class="main-section-title">客户评价</div>
        <div class=" main-section-description">来自满意客户的一些评论。</div>
        <div class="clients-reviews-main">
          <el-carousel :height="hei">
            <el-carousel-item v-for="(item, index) in 5" :key="index">
              <el-row>
                <el-col
                  :xs="12"
                  :sm="12"
                  :md="6"
                  :lg="6"
                  :xl="6"
                  v-for="item in comments.slice(index * 4, index * 4 + 4)"
                  :key="item.id"
                >
                  <Cards :item="item" key="item.id" />
                </el-col>
              </el-row>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </section>

    <!-- banner -->
    <section class="split-section animate__animated animate__fadeInUp">
      <div class="split-section-text-wrap">
        <p class="split-section-t1">18,000+</p>
        <p class="split-section-t2">众多客户喜爱</p>
        <div class="contact-icon">
<!--          <el-link href="https://twitter.com/CardEshop">-->
<!--            <svg-->
<!--              t="1650103919423"-->
<!--              class="icon"-->
<!--              viewBox="0 0 1024 1024"-->
<!--              version="1.1"-->
<!--              xmlns="http://www.w3.org/2000/svg"-->
<!--              p-id="30682"-->
<!--              data-spm-anchor-id="a313x.7781069.0.i7"-->
<!--              width="24"-->
<!--              height="24"-->
<!--            >-->
<!--              <path-->
<!--                d="M1024 512c0-282.763636-229.236364-512-512-512C229.236364 0 0 229.236364 0 512s229.236364 512 512 512C794.763636 1024 1024 794.763636 1024 512zM236.311273 693.946182c8.843636 1.117091 17.873455 1.722182 26.996364 1.722182 53.015273 0.093091 101.794909-19.037091 140.474182-51.153455-49.524364-1.163636-91.275636-36.165818-105.658182-84.200727 6.888727 1.442909 14.010182 2.280727 21.271273 2.327273 10.333091 0.046545 20.293818-1.349818 29.789091-4.049455-51.758545-11.450182-90.763636-60.555636-90.763636-119.063273 0-0.512 0-1.024 0-1.536 15.266909 9.216 32.674909 14.801455 51.246545 15.639273C279.365818 431.709091 259.397818 394.472727 259.397818 352.581818c0-22.155636 5.585455-42.821818 15.313455-60.509091 55.808 73.774545 139.170909 122.740364 233.146182 128.837818-1.954909-8.797091-2.932364-17.966545-2.932364-27.322182 0-66.141091 50.641455-118.923636 113.105455-117.899636 32.535273 0.558545 61.952 15.499636 82.571636 38.958545 25.786182-4.933818 49.989818-14.429091 71.819636-27.694545-8.424727 27.601455-26.391273 50.594909-49.757091 64.977455 22.900364-2.56 44.683636-8.610909 64.977455-17.780364-15.173818 23.598545-34.350545 44.218182-56.459636 60.695273 0.232727 5.12 0.325818 10.24 0.325818 15.36 0 157.044364-113.803636 338.152727-321.861818 338.059636C345.832727 748.311273 286.347636 728.296727 236.311273 693.946182z"-->
<!--                p-id="30683"-->
<!--                fill="#ffffff"-->
<!--              ></path>-->
<!--            </svg>-->
<!--          </el-link>-->
          <el-link href="https://t.me/Crowncard888">
            <svg
              t="1650104227581"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="32547"
              width="24"
              height="24"
            >
              <path
                d="M679.428571 746.857143l84-396q5.142857-25.142857-6-36t-29.428571-4L234.285714 501.142857q-16.571429 6.285714-22.571428 14.285714t-1.428572 15.142858 18.285715 11.142857l126.285714 39.428571 293.142857-184.571428q12-8 18.285714-3.428572 4 2.857143-2.285714 8.571429l-237.142857 214.285714-9.142857 130.285714q13.142857 0 25.714285-12.571428l61.714286-59.428572 128 94.285715q36.571429 20.571429 46.285714-21.714286z m344.571429-234.857143q0 104-40.571429 198.857143t-109.142857 163.428571-163.428571 109.142857-198.857143 40.571429-198.857143-40.571429-163.428571-109.142857-109.142857-163.428571T0 512t40.571429-198.857143 109.142857-163.428571T313.142857 40.571429 512 0t198.857143 40.571429 163.428571 109.142857 109.142857 163.428571 40.571429 198.857143z"
                p-id="32548"
                fill="#ffffff"
              ></path>
            </svg>
          </el-link>
        </div>
      </div>
      <img
        src="../../images/index/card-banner1.png"
        alt=""
        class="right-img hidden-sm-and-down"
      />
    </section>

    <!-- form -->
    <section class="contact-section animate__animated animate__fadeInUp">
      <div class="contact-section-title">联系我们</div>
      <div class="contact-section-wrap">
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="10" :xl="10">
            <div class="contact-section-detail">
              <p><span class="blue-color">电话: +61-3-9292-8888</span></p>
              <p class="contact-address">
                迪拜阿尔巴沙2区拉丝西商务中心大楼309室<br/>
                Office 509, Rasis Business Center Building, Al Barsha 1, Dubai, UAE
              </p>
              <p class="contact-section-time">
                星期一至星期五 09.00 — 23.00
              </p>
              <p class="contact-section-time">
                星期六至星期天 11.00 — 02.00
              </p>
            </div>
            <div class="contact-section-detail">
<!--              <p><span class="blue-color">电话: 782 366 5555</span><span class="small-font"> (加拿大号码，拨打前加国际区号+1)</span></p>-->
<!--              <p><span class="blue-color">邮箱: </span>jinhuigzs@outlook.com </p>-->
<!--              <p class="contact-address">-->
<!--                320 Bay St.,Toronto,OntarioM5H 4A6,Canada-->
<!--              </p>-->
<!--              <p class="contact-section-time">-->
<!--                星期一至星期五 09.00 — 23.00-->
<!--              </p>-->
<!--              <p class="contact-section-time">-->
<!--                星期六至星期天 11.00 — 02.00-->
<!--              </p>-->
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="10" :xl="10">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              class="demo-ruleForm"
            >
              <el-form-item label="" prop="name">
                <el-input
                  v-model="ruleForm.name"
                  type="text"
                  autocomplete="off"
                  placeholder="名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="" prop="email">
                <el-input
                  v-model="ruleForm.email"
                  type="text"
                  autocomplete="off"
                  placeholder="邮箱地址"
                ></el-input>
              </el-form-item>
              <el-form-item label="" prop="info">
                <el-input
                  v-model="ruleForm.info"
                  type="textarea"
                  autocomplete="off"
                  placeholder="消息"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" round @click="submitForm('ruleForm')"
                  >发送消息</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>

<script>
import VideoJs from '@/components/video-js';
import 'video.js/dist/video-js.css';
import Cards from "@/components/card.vue";
import enums from "../comments/enum";
import { getComments } from "@/api/index";
import { getHelps } from "@/api/index";
import {isMobile, setUUid} from "../../utils/utils";
const vips = [
  require("../../images/index/vip1.png"),
  require("../../images/index/vip1.png"),
  require("../../images/index/vip2.png"),
  require("../../images/index/vip3.png"),
  require("../../images/index/vip4.png"),
  require("../../images/index/vip5.png"),
  require("../../images/index/vip6.png")
];
export default {
  props: {
    sign: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      wid: 0,
      tips: [
        [vips[1], "****6489@qq.com兑换了50张话费充值卡", "-6"],
        [vips[1], "****6954@qq.com兑换了10张京东E卡", "-15"],
        [vips[2], "****died@hotmail.com兑换了50张话费充值卡", "-12"],
        [vips[5], "****2130@gmail.com兑换了50张中石化加油卡", "-4"],
        [vips[4], "****mous@126.com兑换了10张沃尔玛购物卡", "-21"],
        [vips[3], "****2450@qq.com兑换了10张中石化加油卡", "-9"],
        [vips[3], "****xdvs@hotmail.com兑换了100张话费充值卡", "-12"],
        [vips[1], "****6357@gmail.com兑换了5张中石化加油卡", "-4"],
        [vips[6], "****1735@qq.com兑换了10张京东E卡", "-15"]
      ],
      c1: require("../../images/index/c1.png"),
      c2: require("../../images/index/c2.png"),
      c3: require("../../images/index/c3.png"),
      c4: require("../../images/index/c4.png"),
      recordPic: require("../../images/index/record.png"),
      QA: [],
      helpList: [],
      comments: enums,
      ruleForm: {
        name: "",
        email: "",
        info: ""
      },
      open: false,
      dialogWidth: '80%',
      rules: {
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        email: [{ required: true, message: "邮箱不能为空", trigger: "blur" }],
        info: [{ required: true, message: "消息不能为空", trigger: "blur" }]
      },
      videoOptions: {
        controls: true,//开启交互，即是用户可控。
        muted: false,//开启视频时是否静音
        fluid: true,//根据外层css样式大小，自动填充宽高！比较实用，可搭配响应式
        reload: "auto",//重载
        sources: [//视频播放源，建议本地
          {
            src: "https://huiyi.store/test.mp4",
            type: "video/mp4"
          }
        ]
      }
    };
  },
  computed: {
    hei() {
      return this.wid > 992 ? "400px" : "650px";
    }
  },
  created() {
    window.scrollTo(0, 0);
    this.getCommentList();
    this.getHelpList()
  },
  mounted() {
    setUUid()
    if (isMobile()) {
      this.dialogWidth = '80%';
    } else {
      this.dialogWidth = '50%';
    }
    this.$nextTick(() => {
      this.wid = document.body.clientWidth;
      window.addEventListener("resize", this.handleWid);
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWid);
  },
  methods: {
    showVideo(){
      this.open = true
      this.$refs.videoJs.play();
    },
    closeDialog(){
      this.$refs.videoJs.pause();
      this.open = false
    },
    getCommentList() {
      getComments().then(res => {
        const data = res.rows;
        this.comments = data;
        for (let i = 0; i < data.length; i++) {
          this.comments[i].avatar = enums[i].avatar;
        }
      });
    },
    getHelpList() {
      getHelps().then(res => {
        this.helpList = res.data;
        var array=[];
        for (let i = 0; i < this.helpList.length; i++) {
          array.push(i)
        }
        this.QA = array
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$message({
            type: "success",
            message: "发送成功"
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleWid() {
      this.wid = document.body.clientWidth;
    },
    goCardDetail() {
      if (this.sign) {
        this.$router.push({
          path: "/buy",
          query: {
            id: 5
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: "请先登录！"
        });
      }
    },
    goCard() {
      this.$router.push({
        path: "/buy"
      });
    },
    scrollNum(question) {
      document.querySelector("#" + question).scrollIntoView();
    },
    goUser() {
      if (this.sign) {
        this.$router.push({
          path: "/user"
        });
      } else {
        this.$message({
          type: "warning",
          message: "请先登录！"
        });
      }
    }
  },
  components: {
    Cards,
    VideoJs
  }
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue